import { Component, Input, OnChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-property-location',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './property-location.component.html',
  styleUrls: ['./property-location.component.scss']
})
export class PropertyLocationComponent implements OnChanges {

  @Input() selectedItem: any;

  mapUrl: SafeResourceUrl | null = null;
  directionsUrl: string | null = null;

  constructor(private sanitizer: DomSanitizer) {}

  ngOnChanges(): void {
    const address = this.formatAddress(this.selectedItem);
    this.mapUrl = address
      ? this.sanitizer.bypassSecurityTrustResourceUrl(
          `https://maps.google.com/maps?q=${encodeURIComponent(address)}&output=embed`
        )
      : null;
    this.directionsUrl = this.selectedItem?.location || (address
      ? `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(address)}`
      : null);
  }

  formatAddress(item: any): string {
    if (!item) return '';

    return [
      item.name,
      item.address,
      item.streetName,
      item.cityName,
      item.stateName,
    ]
      .filter((part): part is string => typeof part === 'string' && part.trim() !== '')
      .map((part) => part.trim())
      .join(', ');
  }
}
